export default "__VITE_ASSET__D_zrw_94__"